export const invalidateCache=async(queryClient,queryKey)=>{await queryClient.cancelQueries(queryKey);await queryClient.invalidateQueries(queryKey)};